/*******************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 *******************************************************************************/
'use strict';

var client = require('./client'),
  config = require('./config'),
  jsonPayload = require('../client/json-payload'),
  requireServer = require('./require-server'),
  staticResourceManifest = requireServer('../server/static-resource-manifest');
exports.manifest = client ? jsonPayload.get('resource-manifest') : staticResourceManifest;
exports.href = function (relativePath, cdnDomain) {
  var etag = exports.manifest[relativePath],
    cdnPrefix = cdnDomain ? "https://".concat(cdnDomain) : '',
    href = "".concat(cdnPrefix).concat(config.CONTEXT_PATH);
  if (etag) {
    href += "/static/".concat(etag, "/").concat(relativePath);
  } else {
    href += "/".concat(relativePath);
  }
  if (config.ENV_ID) {
    href += "?env_id=".concat(config.ENV_ID);
  }
  return href;
};